import { FC, useCallback } from "react";
import {
    Heading,
    Text,
    Container,
    Button,
    Flex,
} from "@smile2impress/components/relaunch";
import { useRouter } from "next/router";
import { useAnalyticsId } from "hooks/useAnalyticsId";

import { Icon } from "components/Icons";
import LogoIcon from "components/Icons/icons/logo.svg";
import Link from "components/Link";
import { ErrorPropsItem, Site } from "content/error/types";
import { AnalyticsIdElement } from "constants/analytics";

export const ErrorApi: FC<ErrorPropsItem & { site?: Site }> = ({
    title,
    site,
    subtitle,
    button,
}) => {
    const router = useRouter();

    const handleReload = useCallback(() => {
        router.reload();
    }, []);

    const getAnalyticsId = useAnalyticsId();

    return (
        <Container
            position="relative"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minH="100vh"
            pt="24px"
            pb="24px"
        >
            <Link
                {...site}
                href={site?.link || "/"}
                id={getAnalyticsId({
                    zone: "header",
                    element: AnalyticsIdElement.LINK,
                    label: "logo",
                })}
                position="absolute"
                top="24px"
                width={["140px", "160px"]}
                height={["28px", "32px"]}
            >
                <Icon>
                    <LogoIcon />
                </Icon>
            </Link>
            <Flex justifyContent="center">
                <Container size="m">
                    <Heading mb={["1", "2"]} as="h3" textStyle="title1">
                        {title}
                    </Heading>
                    <Text mb="10" textStyle="body">
                        {subtitle}
                    </Text>
                </Container>
            </Flex>
            {button?.text && (
                <Flex justifyContent="center">
                    <Button onClick={handleReload}>{button.text}</Button>
                </Flex>
            )}
        </Container>
    );
};
